<template>
  <!--页面加载动画-->
  <div class="occupation-box">
    <span class="defaultTxt" @click="start()">
      {{defaultTxt || "请选择职业"}}
      <i class="iconfont iconzhankai-xianxing"></i>
    </span>
    <div class="occupation-layer-box" v-show="hasDatas && showLayer" @touchmove.prevent>
      <div class="mask"></div>
      <div class="mainContent">
        <div class="top-btn">
          <span @click="handleCancle" class="btn btn-cancle">取消</span>
          <span @click="handleSure" class="btn btn-sure">确认</span>
        </div>
        <div class="search">
          <input type="search" placeholder="例如：教师" @input="search" ref="occu_input" />
          <i class="iconfont icon-sousuo"></i>
        </div>
        <div class="treemenu-box" :id="scrollId">
          <ul class="tree treemenu">
            <li
              class="tree-option tree-level-1"
              v-for="(children1,i) in allData"
              v-show="children1.show"
            >
              <span :class="[{'toggler-active':checkItem[0].code===children1.code},'toggler']">
                <i class="iconfont iconinfo"></i>
                {{children1.name}}
              </span>
              <ul class="tree-show tree" v-if="children1.children && children1.children.length>0 && firstLoad">
                <li
                  class="tree-option tree-level-2"
                  v-for="(children2,n) in children1.children"
                  v-show="children2.show"
                  @click.stop="trigger(1,i,n)"
                >
                  <span :class="[{'toggler-active':checkItem[1].code===children2.code},'toggler']">
                    {{children2.name}}
                    <i :class="[{active:children2.open},'iconfont iconxiala']"></i>
                  </span>
                  <ul
                    :class="[{'tree-show':children2.open},'tree']"
                    v-if="children2.children && children2.children.length>0 && children2.open"
                  >
                    <li
                      class="tree-option tree-level-3"
                      v-for="(children3,m)  in children2.children"
                      v-show="children3.show"
                      @click.stop="trigger(2,i,n,m)"
                    >
                      <span
                        :class="[{'toggler-active':checkItem[2].code===children3.code},'toggler']"
                      >
                        {{children3.name}}
                        <i
                          class="iconfont icongou"
                          v-show="checkItem[2].code===children3.code"
                        ></i>
                      </span>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash"; //lodash.js
var vm;
var timor;
export default {
  data() {
    return {
      allData: Array, //选择元素
      showLayer: false, //是否弹窗选择框
      hasDatas: false, //数据是否加载完成
      defaultTxt: "", //是否弹窗选择框
      myScroll:null,//isscroll对象
      scrollId:'',//isscroll对象
      checkItem: [
        {
          name: "",
          code: ""
        },
        {
          name: "",
          code: ""
        },
        {
          name: "",
          code: ""
        }
      ], //当前滑动选择项
      itemNum: 3, //默认级联数
      firstLoad:false,//是否第一次加载
    };
  },
  props: ["selectData", "proId"],
  mounted() {
    vm=this;
    this.defaultTxt = this.selectData.elementValue
      ? this.selectData.elementValue[2].name
      : "";
      this.scrollId="scroll_"+this.$tools.randomRangeId(5);
      this.getDatas();
  },
  methods: {
    start() {
      if(!this.hasDatas){
        return this.$notice.msg("职业数据正在加载，请您稍后几秒钟再选择！")
      }
      this.showLayer = true;
      this.firstLoad=true;
      setTimeout(this.scrolled,100);
    },
    /**
     * 选择触发
     */
    trigger(level, index1, index2, index3) {
      console.log("触发职业选择",level+"_"+index1+"_"+index2+"_"+index3);
      this.$refs.occu_input.blur();
      if (level == 0) {
        this.allData[index1].open = !this.allData[index1].open;
      } else if (level == 1) {
        this.allData[index1].children[index2].open = !this.allData[index1]
          .children[index2].open;
      } else if (level == 2) {
        this.allData[index1].children[index2].children[index3].open = !this
          .allData[index1].children[index2].children[index3].open;
        this.checkItem = [
          {
            name: this.allData[index1].name,
            code: this.allData[index1].code
          },
          {
            name: this.allData[index1].children[index2].name,
            code: this.allData[index1].children[index2].code
          },
          {
            name: this.allData[index1].children[index2].children[index3].name,
            code: this.allData[index1].children[index2].children[index3].code,
            riskLevel: this.allData[index1].children[index2].children[index3].riskLevel,
          }
        ];
      }
      this.refresh()
    },
    search(e){
      if(timor)clearTimeout(timor);
      timor=setTimeout(()=>{
        this.searchResult(e.target.value);
          this.refresh()
      },1000)
    },
    refresh(){
      if(!this.myScroll)return;
      setTimeout(() => {
          this.myScroll.refresh();
        }, 100);
    },
    /**
     * 搜索遍历
     * txt-搜索文案
     */
    searchResult(txt) {
      console.log(txt);
      if (!txt) {
        this.allData.forEach(item => {
          item.show = true;
          item.children.forEach(item2 => {
            item2.show = true;
            item2.children.forEach(item3 => {
              item3.show = true;
            });
          });
        });
        return;
      }
      this.allData.forEach(item => {
        if (!item.children) {
          item.show = false;
          return;
        }
        let check1 = false;
        item.children.forEach(item2 => {
          if (!item2.children) {
            item2.show = false;
            return;
          }
          let check2 = false;
          item2.children.forEach(item3 => {
            if (item3.name.indexOf(txt) > -1) {
              check2 = true;
              item3.show = true;
            } else {
              item3.show = false;
            }
          });
          if (check2) {
            item2.show = true;
            check1 = true;
          } else {
            item2.show = false;
          }
        });
        item.show = check1 ? true : false;
      });
    },
    handleSure(index) {
      //munt 选择回调-确认
      if (!this.checkItem[0].name || !this.checkItem[0].name) {
        this.$notice.msg("您还未选择职业！");
        return;
      }
      this.showLayer = false;
      this.defaultTxt = this.checkItem[2].name;
      this.getResult();
    },
    handleCancle() {
      //munt 选择回调-取消
      this.showLayer = false;
    },
    getDatas() {
      //获取职业数据
      const productCode = this.$store.state.productBaseInfo.productCode;
      this.$http({
        url: "/insure/professions",
        type: "GET",
        data: {
          productCode: productCode,
          occupationType: this.selectData.params || ""
        }
      })
        .then(data => {
          if (!data.data) return;
          this.allData = this.initDatas(data.data);
          console.log("this.allData",this.allData);
          this.hasDatas = true;
        })
        .catch(err => {
          console.log(err);
        });
    },
    initDatas(data) {
      //初始化数据
      data.forEach(item => {
        item.show = true;
        item.open = false;
        item.children =
          item.children && item.children.length > 0
            ? this.initDatas(item.children)
            : undefined;
      });
      return data;
    },
    getResult() {
      //选择后回调到父组件
      let value = this.checkItem;
      this.selectData.elementValue = value;
      console.log("职业选择--", value);

      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value
      });
    },
    iScrollClick() {
      if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) return true;
      if (/Chrome/i.test(navigator.userAgent))
        return /Android/i.test(navigator.userAgent);
      if (/Silk/i.test(navigator.userAgent)) return false;
      if (/Android/i.test(navigator.userAgent)) {
        var s = navigator.userAgent.substr(
          navigator.userAgent.indexOf("Android") + 8,
          3
        );
        return parseFloat(s[0] + s[3]) < 44 ? false : true;
      }
    },
    // 屏幕滑动，修改导航高亮元素
    scrolled() {
      if(this.myScroll){
        return this.refresh()
      };
      let click=this.iScrollClick();
      console.log("click",click);
      let myScroll = new IScroll("#"+this.scrollId, {
        click: click,
        mouseWheel: true,
        scrollbars: true,
        fadeScrollbars: true,
        bounce: false,
        interactiveScrollbars: true,
        bounceEasing: "quadratic"
      });

      this.myScroll = myScroll;
    },
  }
};
</script>

<style lang="scss" scoped>
.occupation-box {
  width: 100%;
  height: 100%;
  .iconzhankai-xianxing {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 36px;
  }
  .defaultTxt {
    width: 100%;
    height: 100%;
    line-height: 40px;
    font-size: 30px;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 50px;
    display: inline-block;
  }
  .occupation-layer-box {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.5);
      z-index: 1;
    }
    .mainContent {
      position: absolute;
      width: 10rem;
      height: 80%;
      left: 50%;
      bottom: 0;
      z-index: 2;
      background-color: #fff;
      transform: translateX(-50%);
      padding-top: 160px;
    }
    .top-btn {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 80px;
    }
    .btn {
      line-height: 80px;
      padding: 0 20px;
    }
    .btn-cancle {
      float: left;
    }
    .btn-sure {
      float: right;
      color: #0084ff;
    }
    .search {
      position: absolute;
      top: 80px;
      width: 100%;
      height: 80px;
      padding: 10px 20px;
      background-color: #f5f5f5;
      input {
        display: block;
        width: 100%;
        height: 60px;
        background-color: #fff;
        border: none;
        padding: 0 30px 0 70px;
        font-size: 30px;
        color: #666;
        border-radius: 50px;
      }
      .iconfont {
        display: inline-block;
        position: absolute;
        top: 50%;
        left: 40px;
        width: 30px;
        transform: translateY(-50%);
        font-size: 36px;
        color: #999;
      }
    }
    .treemenu-box{
      width: 100%;
      height: 100%;
      overflow: hidden;
      background-color: #f5f5f5;
      z-index: 2;
    }
    .treemenu {
      width: 100%;
      min-height: 100%;
      .tree {
        display: none;
        &.tree-show {
          display: block;
        }
      }
      .tree-option {
        width: 100%;
      }
      .tree-level-1 {
        background-color: #fff;
        margin-bottom: 10px;
        > .toggler {
          line-height: 40px;
          padding: 20px 0;
          font-size: 32px;
          text-align: center;
          border-bottom: 1px solid #eee;
        }
      }
      .tree-level-2 {
        > .tree {
          background-color: #f5f5f5;
        }
        > .toggler {
          line-height: 40px;
          padding: 15px 50px 15px 20px;
          font-size: 30px;
          text-align: left;
          border-bottom: 1px solid #eee;
        }
        &:last-child > .toggler {
          border-bottom: none;
        }
      }
      .tree-level-3 {
        padding: 0 50px;
        > .toggler {
          line-height: 40px;
          padding: 15px 30px 15px 0;
          font-size: 28px;
          text-align: left;
          border-bottom: 1px dashed #e2e2e2;
        }
        &:last-child .toggler {
          border-bottom: none;
        }
      }
      .toggler {
        display: block;
        position: relative;
        color: #666;
        font-size: 30px;
        line-height: 40px;
        padding-right: 40px;
      }
      .iconxiala {
        position: absolute;
        right: 20px;
        top: 50%;
        font-size: 30px;
        color: #999;
        transition: all 0.5s linear;
        margin-top: -20px;
        &.active {
          transform: rotate(-180deg);
        }
      }
      .icongou {
        position: absolute;
        right: 0;
        top: 50%;
        font-size: 30px;
        color: #0084ff;
        transform: translateY(-50%);
      }
      .toggler-active {
        color: #0084ff;
      }
      .toggler-icon {
        display: inline-block;
        width: 15px;
        text-align: center;
      }
    }
  }
}
</style>
